import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { MatchDetail } from "@app/core/match/domain/model/match-detail";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { MatchDetailMapper } from "./match-detail.mapper";

export type MatchCompareResponse = {
  myself: MatchDetail;
  partner: MatchDetail;
  rivalBackhand: MatchDetail;
  rivalDrive: MatchDetail;
}

export function deserializeMatchCompare(response: any): MatchCompareResponse {
  return response.reduce((acc: any, item: any) => {
    const comparedKey = item.statistics.compared;
    acc[comparedKey] = MatchDetailMapper.deserialize(item.statistics);
    acc[comparedKey].player = item.player;
    return acc;
  }, {});
}

/**
 * Web service used to get match detail comparison.
 */
@Injectable({
  providedIn: "root",
})

export class MatchCompareWS {
  constructor(private handler: BaseHandler) {}
  execute(matchId: string, token: string): Observable<MatchCompareResponse> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.MATCH_COMPARE_ENDPOINT(matchId))
      .setMethod(HttpMethod.get)
      .setAuthorization(new TokenAuthorization(token))
      .build();
    return this.handler
      .execute(parameters)
      .pipe(map(deserializeMatchCompare));
  }
}